import axiosIns from '@/libs/axios'

const ROOT_URL = '/script-signals'

export default {
  namespaced: true,
  state: {
    config: null,
    events: [],
    loading: false,
    triggering: false,
    dataSave: { message: null, status: null },
  },
  getters: {
    config: s => s.config,
    events: s => s.events,
    loading: s => s.loading,
    triggering: s => s.triggering,
    enabled: s => Boolean(s.config && s.config.enabled),
    dataSaveStatus: s => s.dataSave,
  },
  mutations: {
    SET_CONFIG(state, data) { state.config = data },
    SET_EVENTS(state, data) { state.events = Array.isArray(data) ? data : [] },
    SET_LOADING(state, val) { state.loading = val },
    SET_TRIGGERING(state, val) { state.triggering = val },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    getConfig({ commit }) {
      commit('SET_LOADING', true)
      return axiosIns.get(`${ROOT_URL}/config`)
        .then(response => {
          commit('SET_CONFIG', response.data.data)
          commit('SET_LOADING', false)
        })
        .catch(error => {
          if (error?.response?.status !== 404) console.error(error)
          commit('SET_CONFIG', null)
          commit('SET_LOADING', false)
        })
    },
    saveConfig({ commit, dispatch }, body) {
      return axiosIns.post(`${ROOT_URL}/config`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Script sinyal ayarları kaydedildi.' })
          dispatch('getConfig')
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Kaydetme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    toggleEnabled({ commit, dispatch }, enabled) {
      return axiosIns.patch(`${ROOT_URL}/config/toggle`, { enabled })
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message })
          dispatch('getConfig')
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Durum değiştirilemedi.' })
        })
    },
    trigger({ commit, dispatch }) {
      commit('SET_TRIGGERING', true)
      return axiosIns.post(`${ROOT_URL}/config/trigger`)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message })
          dispatch('getConfig')
          commit('SET_TRIGGERING', false)
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          commit('SET_TRIGGERING', false)
          const msg = error?.response?.data?.message || 'Koşu başlatılamadı.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    getEvents({ commit }, limit = 100) {
      return axiosIns.get(`${ROOT_URL}/events`, { params: { limit } })
        .then(response => {
          commit('SET_EVENTS', response.data.data)
        })
        .catch(error => {
          console.error(error)
          commit('SET_EVENTS', [])
        })
    },
  },
}
